import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HistoryService } from 'src/app/service/history.service';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Component({
    selector: 'app-report-download',
    templateUrl: './report-download.component.html',
    styleUrls: ['./report-download.component.scss'],
    standalone: false
})
export class ReportDownloadComponent implements OnInit {
  heading: string
  columnDefs: any;
  context: any;
  defaultColDef: any;
  gridApi: any;
  fileNameList = []
  gridOptions:any;

  constructor(public dialogRef: MatDialogRef<ReportDownloadComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any,
    private readonly historyService: HistoryService, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly constants: Constants,) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true,

    }
    this.gridOptions = {
			suppressCellSelection: true,
			context: this.context,
		  }
  }

  ngOnInit(): void {
    this.heading = "Outputs"
    const filteredData = this.dataStore.data.filter((q) => q.queueId == this.dataStore.queueId); // NOSONAR
    filteredData.forEach(element => {
      this.fileNameList.push({ filesToDownload: element.reportFileName })
    })
    this.columnDefs = [{
      headerName: "Files", field: "filesToDownload", minWidth: 416 , maxWidth: 416, cellClass: "left_align",
    }]
  }

  async onRowClick(event) {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    await this.historyService.testService(this.dataStore.queueId, event.data.filesToDownload).then(
      response => {
        if (response?.size >= 1) {
          const fileName = `${event.data.filesToDownload}${EXCEL_EXTENSION}`;
          saveAs(response, fileName);
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        }
        else {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        }
      })
  }

  async zipping() {    
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    const blobs = [];

    // Make API calls to get the Excel sheets as blobs
    this.fileNameList.forEach(element => {
      blobs.push(this.historyService.testService(this.dataStore.queueId, element.filesToDownload))
    })

    const zip = new JSZip();

    this.fileNameList.forEach((index, element) => {
      zip.file(`${index.filesToDownload}.xlsx`, blobs[element]);
    })

    // Generate the zip file
    const content = await zip.generateAsync({ type: 'blob' });

    // Create a download link for the zip file
    const url = window.URL.createObjectURL(content);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Reports.zip';
    document.body.appendChild(link);

    // Click the download link to start the download
    link.click();    
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
  sizeToFit() {
    this.gridApi?.sizeColumnsToFit();
  }

  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
  public saveClick() {
    this.dialogRef.close({
      event: "ConfirmEvent",

    });
  }

}
